module.exports = __webpack_public_path__ + "img/graph1-g.d3bb5477.svg";